//Define super-globals
window.theme = window.theme || {};
window.theme = {
  strings: {
    attentive: {
      subscriptions: {
        form: {
          errors: {
            submitDefault:"An error occurred. Please try again.",
            phone:"Valid format is +12223334444 and US phone numbers only."}
        }
      }
    },
    klaviyo: {
      subscriptions: {
        form: {
          errors: {
            submitDefault:"An error occurred. Please try again."}
        }
      }
    },
    customer: {
      account: {
        update_error_msg:"An error occurred while processing your request."}
    }
  },
  themeSettings: {
    roswell_ext_url:"https:\/\/hatheaven.roswellstudios.com"}
};